export enum LabelCollapseModeEnum {
  Toggle = 'toggle',
  None = 'none',
}
